import ActionTypes from "../../../constants/ActionTypes";
import { ISetPageDataProductListAction, ISetPageDataProductOverviewAction } from "./types";

export function setPageDataProductListAction(pageData: object): ISetPageDataProductListAction {
  return {
    type: ActionTypes.PAGE_DATA_DEVICE_LIST.SET,
    payload: pageData,
  };
}

export function setPageDataProductOverviewAction(pageData: object): ISetPageDataProductOverviewAction {
  return {
    type: ActionTypes.PAGE_DATA_DEVICE_OVERVIEW.SET,
    payload: pageData,
  };
}
